import { useLang } from '@/i18n';
import css from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

interface ItfItem {
    title: string;
    desc: string;
    img: [string, string];
}
const Tab3: React.FC = () => {
    const { t } = useLang('stream.overview');
    const items: ItfItem[] = [
        {
            title: t('E_item3_list1_title'),
            desc: t('E_item3_list1_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1774594569524/e3_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1774594569276/e3_1m.jpg'],
        },
        {
            title: t('E_item3_list2_title'),
            desc: t('E_item3_list2_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1774594569082/e3_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1774594571345/e3_2m.jpg'],
        },
        {
            title: t('E_item3_list3_title'),
            desc: t('E_item3_list3_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1774594571166/e3_3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1774594570860/e3_3m.jpg'],
        },
    ];
    return (
        <ul className={`${css.frag}`}>
            {items?.map((item: ItfItem) => (
                <li className="item" key={item.title}>
                    <EcoImg className="item-img" pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} alt={t('E_item3_list1_title')} />
                    <div className="item-info">
                        <p className="item-title">{item.title}</p>
                        <p className="item-desc">{item.desc}</p>
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default Tab3;
